import {get} from 'lodash';

import {RECORDS_SORTS, SORTS} from '../enum/sort.enum';

export function getDefaultRecordsSort({recordsName}: any) {
  return get(SORTS, get(RECORDS_SORTS, [recordsName, 'default']));
}

export function getSortOptions({recordsName}: any) {
  return get(RECORDS_SORTS, [recordsName, 'items']);
}
